<div class="emma-card__header">{{ "DEVICES.ConnectedDevices" | translate }}</div>
<div class="emma-card__content" fxLayout="column" fxLayoutAlign="center center">
    <h2>{{ connectedDevices }}</h2>
    <div>{{ "DEVICES.Connected" | translate }}</div>
</div>
<div class="emma-card__footer">{{ "DEVICES.Total" | translate }}: {{ deviceNumber }}</div>
